/*
 * Fonte única do locale do frontend (moment, date-fns, Material-UI e <html lang>),
 * derivado do idioma do i18next (pt | en | es).
 *
 * Decisão (30/09/2026): datas continuam DD/MM/YYYY e moeda R$ no padrão BR em todos
 * os idiomas. Aqui só muda o que é texto: nomes de mês/dia, rótulos do MUI
 * (paginação, pickers), calendário etc.
 *
 * Os arquivos de locale do moment são importados SOMENTE aqui: importar um deles
 * troca o locale global como efeito colateral, e applyGlobalLocale() corrige isso.
 */
import i18next from "i18next";
import moment from "moment";
import "moment/locale/pt-br";
import "moment/locale/es";
import { ptBR as dfPtBR, es as dfEs, enUS as dfEnUS } from "date-fns/locale";
import { ptBR as muiPtBR, esES as muiEsES, enUS as muiEnUS } from "@material-ui/core/locale";

const LOCALES = {
  pt: { code: "pt-BR", moment: "pt-br", dateFns: dfPtBR, mui: muiPtBR },
  en: { code: "en-US", moment: "en", dateFns: dfEnUS, mui: muiEnUS },
  es: { code: "es", moment: "es", dateFns: dfEs, mui: muiEsES },
};

export const SUPPORTED_LANGUAGES = Object.keys(LOCALES);

const storedLanguage = () => {
  try {
    return window.localStorage.getItem("i18nextLng");
  } catch (e) {
    return null;
  }
};

// Idioma curto (pt | en | es), sempre um dos suportados.
export const getLang = () => {
  const raw = i18next.language || storedLanguage() || "pt";
  const lng = String(raw).split("-")[0].toLowerCase();
  return LOCALES[lng] ? lng : "pt";
};

export const getLocale = () => LOCALES[getLang()];
export const getLocaleCode = () => getLocale().code;
export const getMomentLocale = () => getLocale().moment;
export const getDateFnsLocale = () => getLocale().dateFns;
export const getMuiLocale = () => getLocale().mui;

export const applyGlobalLocale = () => {
  moment.locale(getMomentLocale());
  if (typeof document !== "undefined") {
    document.documentElement.lang = getLocaleCode();
  }
};

// i18n.t() é lido na renderização (não usamos react-i18next), então nada
// re-renderiza ao trocar o idioma: recarrega a página para aplicar em tudo.
export const changeLanguage = async lang => {
  await i18next.changeLanguage(lang);
  window.location.reload();
};
